<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <JsonCSV
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot) </JsonCSV
        >&nbsp;&nbsp;
        <CButton
          block
          color="success"
          style="width: 150px; float: right"
          @click="msgpage()"
        >
          <i class="fa fa-plus" aria-hidden="true"></i> Add message</CButton
        >
      </CCardHeader>

      <CCardBody>
        <DatePicker
          v-model="value1"
          type="date"
          range
          placeholder="Select date range"
          style="float: left"
        ></DatePicker>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
          <!-- <template #alluserlist="{ item }">
              <td v-if="item.alluserlist==true">
                <CBadge  color="success">Yes</CBadge>
              </td>
              <td v-else>
                 <CBadge  color="danger">No</CBadge>
              </td>
            </template>
            <template #particularlist="{ item }">
              <td v-if="item.particularlist==true">
                <CBadge  color="success">Yes</CBadge>
              </td>
              <td v-else>
              <CBadge  color="danger">No</CBadge>
              </td>
            </template>
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  @click="deleteRoute(item, index)"
                >
                  Delete
                </CButton>
              </td>
            </template> -->
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      tableData: [],
      value1: [],
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },

        {
          label: "Title",
          key: "messagetitle",
          sortable: true,
        },
        {
          label: "Message",
          key: "messagetext",
          sortable: true,
        },
        // {
        //   label: "Delivery count",
        //   key: "messagecount",
        //   sortable: true,
        // },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      this.tableData = [];

      db.collection("messagecount")
        .where("date", ">=", v1)
        .where("date", "<=", v2)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let backenddate =
              doc.data().date != null
                ? moment(doc.data().date.seconds * 1000).format("DD-MMM-YYYY")
                : "";
            this.tableData.push({
              // id: doc.id,
              date: backenddate,
              messagetext: doc.data().messagetext,
              // messagecount: doc.data().messagecount,
              messagetitle: doc.data().messagetitle,
            });
          });

          console.log("this.tableData", this.tableData);
        });
    },
  },
  methods: {
    msgpage() {
      this.$router.push({ name: "messageupdate" });
    },
    getmessage() {
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      db.collection("messagecount")
        .where("date", ">=", startOfToday)
        .where("date", "<=", endOfToday)
        .orderBy("date", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let backenddate =
              doc.data().date != null
                ? moment(doc.data().date.seconds * 1000).format("DD-MMM-YYYY")
                : "";
            this.tableData.push({
              // id: doc.id,
              date: backenddate,
              messagetext: doc.data().messagetext,
              // messagecount: doc.data().messagecount,
              messagetitle: doc.data().messagetitle,
            });
          });

          console.log("this.tableData", this.tableData);
        });
    },

    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
    },

    deleteRoute(item) {
      console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("messagetest")
        .doc(this.documentId)
        .delete()
        .then(() => {
          //   console.log("Document successfully deleted!");
          this.getmessage();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
    // sendmsg(){}
  },
  created() {
    this.getmessage();
    // this.sendmsg();
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
</style>